var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isScheduled && !_vm.isEmpty,
          expression: "isScheduled && !isEmpty",
        },
      ],
      staticClass:
        "body-container no-images show-all-items textual_menu--section menu--section",
      class: _vm.containerClasses,
      attrs: { "data-section-id": _vm.section.ms_id },
    },
    [
      _c("div", {
        staticClass: "page-link-group-hash",
        attrs: { id: _vm.section.ms_id + "-MS" },
      }),
      _vm._v(" "),
      _vm._t("sectionTitleImage"),
      _vm._v(" "),
      "above-title" === _vm.contentAreaTopLayout &&
      _vm.section.ms_content_area_top.length
        ? _c(
            "div",
            {
              staticClass:
                "menu--page_content menu--page_content-top page-link-group-copy",
            },
            [
              _c("div", {
                staticClass: "viewport",
                domProps: {
                  innerHTML: _vm._s(_vm.section.ms_content_area_top),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "h2",
        { staticClass: "menu--section_title", attrs: { tabindex: "-1" } },
        [
          _vm.isTitleBufferVisible ? _c("span") : _vm._e(),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.section.ms_title))]),
          _vm._v(" "),
          _vm.isTitleBufferVisible ? _c("span") : _vm._e(),
          _vm._v(" "),
          _vm.isTitleBoxVisible
            ? _c("span", { staticClass: "menu--section_title_box" })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.sectionMenuType.length
        ? _c("h3", {
            staticClass: "menu--section_menu_type",
            domProps: { innerHTML: _vm._s(_vm.sectionMenuType) },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.sectionMenuType.length && _vm.section.ms_subtitle.length
        ? _c("h3", {
            staticClass: "menu--section_subtitle",
            domProps: { innerHTML: _vm._s(_vm.section.ms_subtitle) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.sectionMenuType.length && _vm.section.ms_subtitle.length
        ? _c("h4", {
            staticClass: "menu--section_subtitle",
            domProps: { innerHTML: _vm._s(_vm.section.ms_subtitle) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.$store.state.isAdminView && _vm.section.normalizedSchedules.length
        ? _c("menu-schedules", {
            attrs: { "normalized-schedules": _vm.section.normalizedSchedules },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("beforeTopContentArea"),
      _vm._v(" "),
      "" === _vm.contentAreaTopLayout && _vm.section.ms_content_area_top.length
        ? _c(
            "div",
            {
              staticClass:
                "menu--page_content menu--page_content-top page-link-group-copy",
            },
            [
              _c("div", {
                staticClass: "viewport",
                domProps: {
                  innerHTML: _vm._s(_vm.section.ms_content_area_top),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.section.grouped_items, function (group, groupTitle) {
        return _c(
          "div",
          { staticClass: "viewport" },
          [
            groupTitle.length && !group.hasOwnProperty(groupTitle)
              ? _c(
                  "h3",
                  { staticClass: "menu--section_group_title" },
                  [
                    _vm._t("beforeGroupTitle"),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(groupTitle))]),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(group, function (subgroup, subgroupTitle) {
              return [
                _c("section-item-subgroup", {
                  attrs: {
                    "menu-item-component": _vm.menuItemComponent.length
                      ? _vm.menuItemComponent
                      : "default-item",
                    "menu-item-tag-location": _vm.menuItemTagLocation,
                    section: _vm.section,
                    "pricing-types":
                      _vm.itemGroupPricingTypes[groupTitle][subgroupTitle],
                    items: subgroup,
                    "is-subgroup-pricing-shown": _vm.isSubgroupPricingShown(
                      groupTitle,
                      subgroupTitle
                    ),
                    "group-title": groupTitle,
                    "subgroup-title": subgroupTitle,
                    "is-page-link-grid": _vm.isPageLinkGrid,
                  },
                }),
              ]
            }),
          ],
          2
        )
      }),
      _vm._v(" "),
      _vm._t("beforeBottomContentArea"),
      _vm._v(" "),
      !_vm.isTagLegendHidden && _vm.section.section_tags.length
        ? _c("menu-tag-legend", {
            attrs: { tags: _vm.section.section_tags, "menu-type": "textual" },
          })
        : _vm._e(),
      _vm._v(" "),
      "none" !== _vm.contentAreaBottomLayout &&
      _vm.section.ms_content_area_bottom.length
        ? _c(
            "div",
            {
              staticClass:
                "menu--page_content menu--page_content-bottom page-link-group-copy",
            },
            [
              _c("div", {
                staticClass: "viewport",
                domProps: {
                  innerHTML: _vm._s(_vm.section.ms_content_area_bottom),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.section.ms_menu_version_override
        ? _c("menu-version", {
            attrs: { version: _vm.section.ms_menu_version_override || "" },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }